import Actions from "@/components/Table/Actions.vue";
import CellEndereco from "@/components/Table/CellEndereco.vue";
import CellContatos from "@/components/Table/CellContatos.vue";

export default {
  components: { Actions, CellEndereco, CellContatos },
  data: () => ({
    termo_pesquisa: "",
    sortBy: "id",
    sortDesc: false,
    isBusy: false,
  }),
  methods: {
    searchTerm() {
      this.pagination.current_page = 1;
      this.loadData();
      this.$router.push({
        query: {
          page: this.pagination.current_page,
          q: this.termo_pesquisa,
        },
      });
    },
    sortingChanged(data) {
      this.sortBy = data.sortBy;
      this.sortDesc = data.sortDesc;
      this.loadData();
    },
    async loadData() {
      this.isBusy = true;
      try {
        await this.ActionGetAll({
          page: this.pagination.current_page,
          per_page: this.pagination.per_page,
          orderBy: this.sortBy,
          sortBy: this.sortDesc ? "desc" : "asc",
          q: this.termo_pesquisa,
        });
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
      this.isBusy = false;
    },
    async deleteItem(item) {
      try {
        await this.ActionDelete(item.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao excluir registro",
          type: "danger",
        });
      }
    },
  },
  async created() {
    if (this.$route.query.q != "") {
      this.termo_pesquisa = this.$route.query.q;
    }
    if (this.$route.query.page > 1) {
      this.pagination.current_page = this.$route.query.page;
    }
    this.loadData();
  },
};
